import { JsonPipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, DestroyRef, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { finalize, timeout } from 'rxjs';
import { JkBaseComponent } from 'jk-service';
import { HindsightSettingsService } from './hindsight-settings.service';
import { RagResponse } from './hindsight.models';

@Component({
  selector: 'app-hindsight-settings', standalone: true, imports: [FormsModule, JsonPipe],
  templateUrl: './hindsight-settings.component.html', changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HindsightSettingsComponent extends JkBaseComponent {
  override comType = 'hindsight-settings';
  private readonly settings = inject(HindsightSettingsService);
  private readonly destroyRef = inject(DestroyRef);
  draft = { ...this.settings.value(), apiBaseUrl: this.settings.value().apiBaseUrl || this.login.host };
  readonly busy = signal(false);
  readonly message = signal('');
  readonly error = signal('');
  readonly details = signal<unknown>(null);

  save(): void {
    this.message.set(''); this.error.set('');
    try {
      this.settings.save(this.draft);
      this.message.set('設定已儲存，下次開啟會自動套用。');
    } catch (error: unknown) {
      this.error.set(error instanceof Error ? error.message : '無法儲存設定，請確認瀏覽器允許本機儲存。');
    }
  }
  checkHealth(): void {
    if (this.busy()) return;
    this.error.set(''); this.message.set(''); this.details.set(null);
    const base = this.draft.apiBaseUrl.trim().replace(/\/+$/, '');
    if (!/^https?:\/\//i.test(base) && !base.startsWith('/')) {
      this.error.set('請輸入完整 http(s) API 網址或以 / 開頭的代理路徑。'); return;
    }
    this.busy.set(true);
    this.http.get<RagResponse>(`${base.endsWith('/rag') ? base : `${base}/rag`}/health`).pipe(
      timeout(190000), takeUntilDestroyed(this.destroyRef), finalize(() => this.busy.set(false)),
    ).subscribe({
      next: result => {
        if (result.result === true) this.message.set('Hindsight 服務連線正常');
        else { this.error.set('Hindsight 健康檢查失敗'); this.details.set(result); }
      },
      error: (error: unknown) => {
        this.error.set('無法連線，請確認 API 網址、服務狀態及 CORS 設定。');
        if (error instanceof HttpErrorResponse) this.details.set(error.error as unknown);
      },
    });
  }
}
